export function tageszeitGruss(jetzt: Date): string {
  const stunde = jetzt.getHours();
  if (stunde < 11) return 'Guten Morgen';
  if (stunde < 18) return 'Guten Tag';
  return 'Guten Abend';
}

function gross(teil: string): string {
  if (!teil) return teil;
  // Nur eine durchgehend grosse Schreibweise (TIM.MOEBIUS@) wird klein gemacht, sonst stuende
  // "TIM" da. Eine gemischte ("McKenzie") ist Absicht und bleibt (Codex-Gate PR #55).
  const rest =
    teil === teil.toLocaleUpperCase('de-DE')
      ? teil.slice(1).toLocaleLowerCase('de-DE')
      : teil.slice(1);
  return teil.charAt(0).toLocaleUpperCase('de-DE') + rest;
}

/**
 * Rueckfall fuer Konten ohne Anzeigenamen: nur aus `vorname.nachname@`. Eine Adresse ohne
 * Punkt (Funktionspostfach, Kuerzel) bekommt lieber keinen Namen als einen falschen.
 */
export function vornameAus(email: string | null): string | null {
  if (!email) return null;
  const lokal = email.split('@')[0] ?? '';
  if (!lokal.includes('.')) return null;
  const vorname = lokal.split('.')[0] ?? '';
  if (!vorname) return null;
  return vorname.split('-').map(gross).join('-');
}

/**
 * Voller Name aus `vorname.nachname@` fuer die Spalte "Angelegt von", nach derselben Regel wie
 * `vornameAus`: Konten ohne Anzeigenamen (`tools/invite-user.js --name`) stuenden sonst nur mit
 * ihrer Adresse da (Rueckmeldung 2026-10-15). Umlaute kennt die Adresse nicht -- "Moebius"
 * bleibt "Moebius", richtig wird es erst mit einem Anzeigenamen.
 */
export function nameAus(email: string | null | undefined): string | null {
  if (!email) return null;
  const lokal = email.split('@')[0] ?? '';
  const teile = lokal.split('.');
  if (teile.length < 2 || teile.some((t) => !t)) return null;
  return teile.map((t) => t.split('-').map(gross).join('-')).join(' ');
}

/**
 * Mit Anzeigenamen (`tools/invite-user.js --name`) wie in der Content-Factory der volle Name
 * ("Guten Tag, Martin Fischer."), sonst der Vorname aus der Adresse.
 */
export function begruessung(
  jetzt: Date,
  email: string | null,
  anzeigename: string | null = null,
): string {
  const gruss = tageszeitGruss(jetzt);
  const name = anzeigename?.trim() || vornameAus(email);
  return name ? `${gruss}, ${name}.` : `${gruss}.`;
}
